<template>
  <div>
    <!-- GPS Map -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Mapa</a>
        </li>
      </ul>
    </div>

    <!-- mapa -->
    <l-map
      ref="map"
      style="height: 500px"
      :zoom="map.zoom"
      :center="map.center"
    >
      <l-tile-layer
        :url="map.url"
        :attribution="map.attribution"
      ></l-tile-layer>
      <l-polygon :lat-lngs="polygon.latlngs" :color="polygon.color"></l-polygon>
      <div>
        <l-marker
          v-for="(item, index) in markers"
          :key="'marker-' + index"
          :lat-lng="item.location"
          :ref="`marker-${item.index}`"
          ><l-popup :options="{ autoClose: false }">{{
            item.text
          }}</l-popup></l-marker
        >
      </div>
      <l-polyline
        @click="fitBounds"
        :lat-lngs="polylineGeneral.latlngs"
        :color="polylineGeneral.color"
      ></l-polyline>
      <l-polyline
        ref="polylineActual"
        @click="fitBounds"
        :lat-lngs="polylineActual.latlngs"
        :color="polylineActual.color"
      ></l-polyline>
      <l-polyline
        @click="fitBounds"
        :lat-lngs="polylineHighlighted.latlngs"
        :color="polylineHighlighted.color"
      ></l-polyline>
    </l-map>
  </div>
</template>

<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LPolygon,
  LPolyline,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "AccessGpsList",

  props: {
    polygons: Array,
    gpsAccessLists: Array,
    routeGeneral: Array,
    routeActual: Array,
    routeHighlighted: Array,
  },

  watch: {
    polygons: function (newVal, oldVal) {
      // watch it
      console.log("Polygones changed: ", newVal, " | was: ", oldVal);

      this.reloadPolygon(newVal);
    },

    gpsAccessLists(newVal, oldVal) {
      // watch it
      console.log("GpsAccessLists changed: ", newVal, " | was: ", oldVal);

      this.reloadMarkers(newVal);
    },

    routeGeneral(newVal, oldVal) {
      // watch it
      console.log("Route changed: ", newVal, " | was: ", oldVal);

      this.reloadRouteGeneral(newVal);
    },

    routeActual(newVal, oldVal) {
      // watch it
      console.log("Route changed: ", newVal, " | was: ", oldVal);

      this.reloadRouteActual(newVal);
    },

    routeHighlighted(newVal, oldVal) {
      // watch it
      console.log("Route highlighted changed: ", newVal, " | was: ", oldVal);

      this.reloadHighlightedRoute(newVal);
    },
  },

  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LPolygon,
    LPolyline,
  },

  data() {
    return {
      selectedLat: 0,
      selectedLng: 0,
      map: {
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        zoom: 8,
        center: [42.788411, 19.270756],
      },
      markers: [],
      polygon: {
        latlngs: [],
        color: "green",
      },
      polylineGeneral: {
        latlngs: [],
        color: "magenta",
        opacity: 0.3,
        dashArray: "20, 20",
        dashOffset: "20",
        weight: 20,
      },
      polylineActual: {
        latlngs: [],
        color: "blue",
        opacity: 1,
        dashArray: "20, 20",
        dashOffset: "20",
        weight: 20,
      },
      polylineHighlighted: {
        latlngs: [],
        color: "red",
        opacity: 1,
        dashArray: "20, 20",
        dashOffset: "20",
        weight: 30,
      },
    };
  },

  mounted() {
    // this.reloadRouteGeneral(this.routeGeneral);
    // this.reloadRouteActual(this.routeActual);

    console.log("POLIGON: ", this.polygons);
    console.log("ROUTE GENERAL: ", this.routeGeneral);
  },

  methods: {
    reloadMarkers(markersArray) {
      this.markers = [];

      let ndx = 0;

      const markers = markersArray[0];

      markers.forEach((m) => {
        this.markers.push({
          index: ++ndx,
          location: [m.insideLatitude, m.insideLongitude],
          text:
            ndx +
            " inside: " +
            new Date(m.insideTime).toLocaleTimeString("sr-latn-cs"),
        });

        this.markers.push({
          index: ++ndx,
          location: [m.outsideLatitude, m.outsideLongitude],
          text:
            ndx +
            " outside: " +
            new Date(m.outsideTime).toLocaleTimeString("sr-latn-cs"),
        });
      });

      console.log("markers");
      console.log(this.markers);
    },

    reloadPolygon(polygonArray) {
      this.polygon.latlngs = [];

      const polygon = polygonArray[0];

      console.log("POLYGON");
      console.log(polygon);

      polygon.GpsPolygonPoint.forEach((gpp) => {
        this.polygon.latlngs.push([gpp.Latitude, gpp.Longitude]);
      });

      this.map.center = this.polygon.latlngs[0];
    },

    fitBounds(object) {
      console.log(object);
      console.log("bounds");

      // const isEmpty = Object.keys(object._bounds).length === 0;
      // console.log(isEmpty);
      // if (isEmpty) return;

      this.$refs.map.fitBounds(object.sourceTarget._bounds);
    },

    reloadRouteGeneral(gpsRoute) {
      if (gpsRoute == undefined) return;

      this.polylineGeneral.latlngs = [];

      console.log("GPS ROUTE!!!, ", gpsRoute);

      gpsRoute.forEach((rp) => {
        // Connect with polylines
        this.polylineGeneral.latlngs.push([rp.Lat, rp.Long]);
      });
    },

    reloadRouteActual(gpsRoute) {
      if (gpsRoute == undefined) return;

      this.polylineActual.latlngs = [];

      gpsRoute.forEach((rp) => {
        // Connect with polylines
        this.polylineActual.latlngs.push([rp.Lat, rp.Long]);
      });
    },

    reloadHighlightedRoute(gpsRoute) {
      console.log(gpsRoute);

      this.polylineHighlighted.latlngs = [];
      this.markers = [];

      let index = 100;
      let counter = 0;
      let COUNTER_DIVIDER = 1;
      if (gpsRoute.length > 10) {
        COUNTER_DIVIDER = 20;
      }
      gpsRoute.forEach((rp) => {
        if (counter++ % COUNTER_DIVIDER === 0) {
          // Show marker
          this.markers.push({
            index: index++,
            location: [rp.Lat, rp.Long],
            text: rp.Lat,
          });
        }

        // Connect with polylines
        this.polylineHighlighted.latlngs.push([rp.Lat, rp.Long]);
      });
    },
  },
};
</script>
